import { Modal } from "@xola/ui-kit";
import React, { useEffect, useState } from "react";
import { ExperiencePurchaseItem, Purchase, PurchaseStatus } from "types";
import { CreatePurchaseItemState, useCreatePurchaseStore } from "../../stores/createPurchaseStore";
import { usePurchaseResponseStore } from "../PurchaseCreate/store/usePurchaseResponseStore";
import { ApplySubmitCodeForm } from "./ApplySubmitCodeForm";
import { PastBookingWarningModalContent } from "./PastBookingWarningModal";

interface CreatePurchaseApplyCouponModalProps {
    isOpen: boolean;
    onClose?: () => void;
}

export const CreatePurchaseApplyCouponModal = ({ isOpen, onClose }: CreatePurchaseApplyCouponModalProps) => {
    const [renderWarningContent, setRenderWarningContent] = useState<"past_event" | null>("past_event");
    const item = useCreatePurchaseStore((state) => state.getActiveItem());
    const purchase = usePurchaseResponseStore((state) => state.purchase);

    useEffect(() => {
        if (!isOpen) {
            setRenderWarningContent("past_event");
        }
    }, [isOpen]);

    const now = new Date();
    const items = item ? [item] : purchase.items ?? [];
    const isPastEvent = items.some((item) => {
        return "arrivalDateTime" in item ? item.arrivalDateTime?.isBefore(now) : false;
    });

    return (
        <Modal size="huge" isOpen={isOpen} onClose={onClose}>
            {purchase.status !== PurchaseStatus.DRAFT && isPastEvent && renderWarningContent === "past_event" ? (
                <PastBookingWarningModalContent onClose={onClose} onContinue={() => setRenderWarningContent(null)} />
            ) : (
                <ApplySubmitCodeForm onClose={onClose} />
            )}
        </Modal>
    );
};

interface ApplyCouponModalProps {
    isOpen: boolean;
    onClose?: () => void;
    purchase: Purchase;
    item: ExperiencePurchaseItem | CreatePurchaseItemState;
}

export const ApplyCouponModal = ({ purchase, item, isOpen, onClose }: ApplyCouponModalProps) => {
    const [renderWarningContent, setRenderWarningContent] = useState<"past_event" | null>("past_event");

    useEffect(() => {
        if (!isOpen) {
            setRenderWarningContent("past_event");
        }
    }, [isOpen]);

    const now = new Date();
    const isPastEvent = (item ? [item] : purchase.items).some((item) => {
        return "arrivalDateTime" in item ? item.arrivalDateTime?.isBefore(now) : false;
    });

    return (
        <Modal size="huge" isOpen={isOpen} onClose={onClose}>
            {purchase.status !== PurchaseStatus.DRAFT && isPastEvent && renderWarningContent === "past_event" ? (
                <PastBookingWarningModalContent onClose={onClose} onContinue={() => setRenderWarningContent(null)} />
            ) : (
                <ApplySubmitCodeForm purchase={purchase} item={item} onClose={onClose} />
            )}
        </Modal>
    );
};

export const ApplyCouponInline = () => {
    return <ApplySubmitCodeForm isInline />;
};
